import { usePointCloudContext } from 'features/pointClouds'
import { useEffect } from 'react'
import { Vector3 } from 'three'

export const HotkeyNavigation = () => {
  const { setFlyToCoordinates, setCoordinatesToLookAtAfterFlight, hotkeys } =
    usePointCloudContext()

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Only handle numeric keys 1-9
      if (event.key >= '1' && event.key <= '9') {
        const hotkeyData = hotkeys?.[event.key]
        if (hotkeyData) {
          setFlyToCoordinates(new Vector3(...hotkeyData.position))
          setCoordinatesToLookAtAfterFlight(new Vector3(...hotkeyData.lookAt))
        }
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [setFlyToCoordinates, setCoordinatesToLookAtAfterFlight, hotkeys])

  return null
}
